import { useState } from "react"
import { AlignCenterOutlined, AlignLeftOutlined, AlignRightOutlined } from "@ant-design/icons"
import { Switch, Form, Input, Radio, Flex } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from "react-i18next"

const ImageForm = ({ formValues, form }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="useCameraMode" label={t("Use Camera Mode")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            
            <Flex align="center" justify="space-between" className="alignment-wrapper">
                <Form.Item label={t("Image Alignment")} name="textAlignment">
                    <Radio.Group>
                        <Radio.Button value="left"><AlignLeftOutlined /></Radio.Button>
                        <Radio.Button value="center"><AlignCenterOutlined /></Radio.Button>
                        <Radio.Button value="right"><AlignRightOutlined /></Radio.Button>

                    </Radio.Group>
                </Form.Item>
            </Flex>


        </>
    )
}

export default ImageForm